import React from 'react';

export default function StaffHeader() {
  return (
      <div className="hero-image-coll">
        <div className="hero-text-coll">
          <h2>Our Staff</h2>
        </div>
      </div>
  );
}
